import { get, post, put } from '@/lib/api/client'
import type {
  ApiResponse,
  PaginatedResponse,
  PaginationParams,
  Subscriber,
  SubscriberFilterParams,
  SubscriberStats
} from '@/lib/api/types'

const getPaginatedSubscribers = async (
  params: PaginationParams = { page: 1, size: 10 },
  filters: SubscriberFilterParams = {}
): Promise<ApiResponse<PaginatedResponse<Subscriber>>> => {
  return await post<ApiResponse<PaginatedResponse<Subscriber>>>(
    `newsletter/private/paginated?page=${params.page}&size=${params.size}`,
    filters
  )
}

export const subscriberService = {
  // Get paginated subscribers
  getPaginatedSubscribers,

  // Get all active subscribers
  getAllActiveSubscribers: async (): Promise<ApiResponse<Subscriber[]>> => {
    return await get<ApiResponse<Subscriber[]>>('newsletter/private/active/all')
  },

  // Get total subscribers count (using paginated response)
  getTotalSubscribersCount: async (): Promise<ApiResponse<number>> => {
    try {
      // Try to get stats endpoint first
      const response = await get<ApiResponse<number>>('newsletter/private/stats/total');
      return response;
    } catch {
      // Fallback: get first page to get total count
      const response = await getPaginatedSubscribers({ page: 1, size: 1 }, {});
      return {
        success: true,
        message: 'Total subscribers count retrieved',
        data: response.data?.totalOfAllElements || 0
      };
    }
  },

  // Get subscribers growth (last 30 days)
  getSubscribersGrowth: async (): Promise<ApiResponse<number>> => {
    return await get<ApiResponse<number>>('newsletter/private/count-last-30-days')
  },

  // Get subscriber stats
  getSubscriberStats: async (): Promise<ApiResponse<SubscriberStats>> => {
    return await get<ApiResponse<SubscriberStats>>('newsletter/private/stats')
  },

  // Unsubscribe a subscriber
  unsubscribe: async (email: string): Promise<ApiResponse<void>> => {
    return await put<ApiResponse<void>>('newsletter/public/unsubscribe', { email })
  }
}

